import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardBody } from '~/components/ui';

export const Route = createFileRoute('/_app/admin/')({
  component: () => (
    <div className="px-6 py-6">
      <h1 className="font-display text-3xl font-bold text-[var(--color-navy)]">Admin</h1>
      <div className="mt-6 grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {[
          { to: '/admin/workflows', label: 'Compliance Workflows', desc: 'Triggers, recipients, escalation' },
          { to: '/admin/tables',    label: 'Database Tables', desc: 'Edit any record' },
          { to: '/admin/users',     label: 'Staff & Roles', desc: 'User management' },
          { to: '/admin/settings',  label: 'Settings', desc: 'System configuration' },
          { to: '/admin/display-tv', label: 'Display TV', desc: 'Office TV slideshow + Yodeck URLs' },
          { to: '/admin/feedback',  label: 'Feedback', desc: 'App feedback from the mobile demo + desktop CRM' },
          { to: '/admin/changelog', label: 'Updates', desc: 'Change log' },
          { to: '/admin/error-log', label: 'Error Log', desc: 'Failed syncs, integration & API errors, client crashes' },
          { to: '/admin/data-flow', label: 'Data Flow Map', desc: 'How each job tab reads, calcs & changes its data' },
          // TEMPORARY — remove this tile when the QC pass is done (see src/data/crmVerification.ts).
          { to: '/admin/verification', label: 'CRM Verification', desc: 'QC checklist + map of every dashboard tab, calc & data source' },
        ].map((t) => (
          <Link key={t.to} to={t.to}>
            <Card className="hover:border-[var(--color-navy)] transition-colors">
              <CardBody>
                <div className="font-display text-xl font-bold text-[var(--color-navy)]">{t.label}</div>
                <div className="text-sm text-[var(--color-ink-soft)] mt-1">{t.desc}</div>
              </CardBody>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  ),
});
